import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useEffect, useState } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { CAN_REDO_COMMAND, CAN_UNDO_COMMAND, COMMAND_PRIORITY_LOW, REDO_COMMAND, UNDO_COMMAND } from "lexical";
import { mergeRegister } from "@lexical/utils";
import { Icon } from "../../../../Icon/index.js";
import { Box } from "../../../../Box/index.js";
import { ToolbarButton } from "../common/index.js";
const UndoRedoPlugin = ()=>{
    const $ = c(24);
    const [editor] = useLexicalComposerContext();
    const [canUndo, setCanUndo] = useState(false);
    const [canRedo, setCanRedo] = useState(false);
    let t0;
    let t1;
    if ($[0] !== editor) {
        t0 = ()=>mergeRegister(editor.registerCommand(CAN_UNDO_COMMAND, (payload)=>{
                setCanUndo(payload);
                return false;
            }, COMMAND_PRIORITY_LOW), editor.registerCommand(CAN_REDO_COMMAND, (payload_0)=>{
                setCanRedo(payload_0);
                return false;
            }, COMMAND_PRIORITY_LOW));
        t1 = [
            editor
        ];
        $[0] = editor;
        $[1] = t0;
        $[2] = t1;
    } else {
        t0 = $[1];
        t1 = $[2];
    }
    useEffect(t0, t1);
    let t2;
    if ($[3] !== canRedo || $[4] !== canUndo || $[5] !== editor) {
        t2 = (command)=>()=>{
                if ("undo" === command && canUndo) return void editor.dispatchCommand(UNDO_COMMAND, void 0);
                if ("redo" === command && canRedo) return void editor.dispatchCommand(REDO_COMMAND, void 0);
            };
        $[3] = canRedo;
        $[4] = canUndo;
        $[5] = editor;
        $[6] = t2;
    } else t2 = $[6];
    const handleClick = t2;
    let t3;
    if ($[7] !== handleClick) {
        t3 = handleClick("undo");
        $[7] = handleClick;
        $[8] = t3;
    } else t3 = $[8];
    const t4 = canUndo ? "text.light.primary" : "text.light.tertirary";
    let t5;
    if ($[9] !== t4) {
        t5 = /*#__PURE__*/ jsx(Icon, {
            name: "arrow_uturn_left_outline",
            size: "20",
            color: t4
        });
        $[9] = t4;
        $[10] = t5;
    } else t5 = $[10];
    let t6;
    if ($[11] !== t3 || $[12] !== t5) {
        t6 = /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: t3,
            tooltip: "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
            children: t5
        });
        $[11] = t3;
        $[12] = t5;
        $[13] = t6;
    } else t6 = $[13];
    let t7;
    if ($[14] !== handleClick) {
        t7 = handleClick("redo");
        $[14] = handleClick;
        $[15] = t7;
    } else t7 = $[15];
    const t8 = canRedo ? "text.light.primary" : "text.light.tertirary";
    let t9;
    if ($[16] !== t8) {
        t9 = /*#__PURE__*/ jsx(Icon, {
            name: "repost_outline",
            size: "16",
            color: t8
        });
        $[16] = t8;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== t7 || $[19] !== t9) {
        t10 = /*#__PURE__*/ jsx(ToolbarButton, {
            onClick: t7,
            tooltip: "\u041F\u043E\u0432\u0442\u043E\u0440\u0438\u0442\u044C \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435",
            children: t9
        });
        $[18] = t7;
        $[19] = t9;
        $[20] = t10;
    } else t10 = $[20];
    let t11;
    if ($[21] !== t10 || $[22] !== t6) {
        t11 = /*#__PURE__*/ jsxs(Box, {
            display: "flex",
            alignItems: "center",
            children: [
                t6,
                t10
            ]
        });
        $[21] = t10;
        $[22] = t6;
        $[23] = t11;
    } else t11 = $[23];
    return t11;
};
export { UndoRedoPlugin };
